import { useQuery } from '@tanstack/react-query';
import Addon from '../models/Addon';

export default function useHolidayAddons() {
  return useQuery(['addons', 'holiday'], () => (
    Addon
      .where({ isHoliday: true })
      .all()
      .then((res) => res.data)
  ), { placeholderData: [] });
}
